// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { DataEventProps } from "../../../../libraries/wpl/foundations/src/index";

export interface ProductNavLinkProps {
    label: string; // header link text
    href: string; // link
    isSelected?: boolean;
    dataEventProps?: DataEventProps;
}

const linkStyle = css`
    & a {
        position: relative;
        top: 3px;
        display: block;
        font-size: 1rem;
        line-height: 1;

        ${media.above.md} {
            margin: 0 ${token("space.200")};
            padding: ${token("space.200")} 0;
            color: #0052cc;
            box-sizing: border-box;
            border-bottom: 3px solid white;
            text-decoration: none;

            &:hover {
                border-bottom: 3px solid #dfe1e5;
                color: rgb(0, 101, 255);
            }
        }

        ${UNSAFE_media.below.md} {
            width: 100%;
            padding: ${token("space.200")} 10px;
            margin: 0 ${token("space.200")};
            color: #0052cc;
            right: 10px;
            text-decoration: underline;

            &:hover {
                text-decoration: none;
                color: rgb(0, 101, 255);
                box-sizing: border-box;
                background-color: #ebecf0;
            }
        }
    }

    .selected {
        font-weight: 600;

        ${media.above.md} {
            border-bottom: 3px solid #0053cc;
            &:hover {
                border-bottom: 3px solid #0053cc;
            }
        }
    }
`;

export const ProductNavLink = (props: ProductNavLinkProps) => {
    return (
        <div css={linkStyle}>
            <a
                className={props.isSelected ? "selected" : ""}
                href={props.href}
                {...props.dataEventProps}
                data-label={props.label}
            >
                {props.label}
            </a>
        </div>
    );
};

export default ProductNavLink;
